export const columns = [
    {
        title:'参与日期',
        dataIndex:"createTime",
        key:"createTime",
        width: 180
    },
    {
        title:'主办单位',
        dataIndex:"name",
        key:"name",
        width: 180,
    },
    // {
    //     title:'手机号',
    //     dataIndex:"phone",
    //     key:"phone",
    //     width: 140,
    // },
    {
        title:'会议名称',
        dataIndex:"meetingName",
        key:"meetingName",
        width: 180,
    },
    {
        title:'会议日期',
        dataIndex:"startDate",
        key:"startDate",
        width: 170,
		slots:"startDate",
    },
    {
        title:'用电量(kWh)',
        dataIndex:"energyUsage",
        key:"energyUsage",
        width: 100,
    },
    {
        title:'航空距离(km)',
        dataIndex:"aviationKilometers",
        key:"aviationKilometers",
        width: 100,
    },
    {
        title:'铁路距离(km)',
        dataIndex:"railwayKilometers",
        key:"railwayKilometers",
        width: 100,
    },
    {
        title:'水运距离(km)',
        dataIndex:"waterKilometers",
        key:"waterKilometers",
        width: 100,
    },
    {
        title:'燃油小汽车距离(km)',
        dataIndex:"gasolineKilometers",
        key:"gasolineKilometers",
        width: 110,
        align:'center'
    },
    {
        title:'纯电小汽车距离(km)',
        dataIndex:"pureElectricKilometers",
        key:"pureElectricKilometers",
        width: 110,
        align:'center'
    },
    {
        title:'公交大巴距离(km)',
        dataIndex:"busKilometers",
        key:"busKilometers",
        width: 100,
        align:'center'
    },
    {
        title:'住宿房间数',
        dataIndex:"accommodationNum",
        key:"accommodationNum"
    },
    {
        title:'住宿天数',
        dataIndex:"accommodationDays",
        key:"accommodationDays"
    },
    {
        title:'早餐人数',
        dataIndex:"breakfastPersons",
        key:"breakfastPersons"
    },
    {
        title:'午餐人数',
        dataIndex:"lunchPersons",
        key:"lunchPersons"
    },
    {
        title:'晚餐人数',
        dataIndex:"dinnerPersons",
        key:"dinnerPersons"
    },
    // {
    //     title: "操作",
    //     slots:'actions',
    //     width:150,
    //     fixed:'right'
    // },
]
export const columns1 = [
    {
        title:'参与日期',
        dataIndex:"createTime",
        key:"createTime",
        width: 180
    },
    {
        title:'姓名/单位',
        dataIndex:"name",
        key:"name"
    },
    {
        title:'手机号',
        dataIndex:"phone",
        key:"phone",
        width: 140,
    },
    {
        title:'出发地',
        dataIndex:"startingPoint",
        key:"startingPoint",
		width: 200,
    },
    {
        title:'目的地',
        dataIndex:"destination",
        key:"destination",
		width: 200,
    },
    {
        title:'交通方式',
        dataIndex:"transport",
        key:"transport",
        slots:"transport",
    },
    // {
    //     title:'公里数(km)',
    //     dataIndex:"kilometers",
    //     key:"kilometers",
    //     width: 100,
    //     align:'center'
    // },
    {
        title:'市内交通里程(km)',
        dataIndex:"indoorKilometers",
        key:"indoorKilometers",
        width: 100,
        align:'center'
    },
    {
        title:'餐饮天数',
        dataIndex:"cateringDays",
        key:"cateringDays",
    },
    {
        title:'住宿天数',
        dataIndex:"accommodationDays",
        key:"accommodationDays",
    },
    {
        title:'植物园次数',
        dataIndex:"botanicalGardenNums",
        key:"botanicalGardenNums",
    },
    {
        title:'主题公园次数',
        dataIndex:"themeParkNums",
        key:"themeParkNums",
        width: 100,
    },
    {
        title:'自然观光次数',
        dataIndex:"naturalSightseeingNums",
        key:"naturalSightseeingNums",
        width: 100,
    },
    {
        title:'文化景区次数',
        dataIndex:"culturalScenicNums",
        key:"culturalScenicNums",
        width: 100,
    },
    {
        title:'泼水狂欢次数',
        dataIndex:"waterFestivalNums",
        key:"waterFestivalNums",
        width: 100,
    },
    {
        title:'放孔明灯次数',
        dataIndex:"kmLanternNums",
        key:"kmLanternNums",
        width: 100,
    },
    {
        title:'放水灯次数',
        dataIndex:"waterLanternNums",
        key:"waterLanternNums",
    },
    {
        title:'民族文化系列活动次数',
        dataIndex:"nationalCultureNums",
        key:"nationalCultureNums",
    },
    {
        title:'自然活动次数',
        dataIndex:"naturalActivityNums",
        key:"naturalActivityNums",
        width: 100,
    },
    // {
    //     title: "操作",
    //     slots:'actions',
    //     width:150,
    //     fixed:'right'
    // },
]
